const meta_data = {
    "meta.title.home": "1-DAY ACUVUE® DEFINE®",
    "meta.desc.home": "Science, art and technology-backed daily disposable lenses crafted for the best of beauty, comfort and health.",
    "meta.title.vm": "Try On ACUVUE® DEFINE® Lenses Virtually",
    "meta.desc.vm": "Explore the best 1-DAY ACUVUE® DEFINE® lenses for you, on you.",
    "meta.title.discover": "Discover the ACUVUE® DEFINE® catalogue",
    "meta.desc.discover": "Craft your beautiful with a range of natural-toned hues and nature-inspired colours",
    "meta.title.classic": "Discover ACUVUE® DEFINE® Classic",
    "meta.desc.classic": "1-DAY ACUVUE® DEFINE® CLASSIC coloured contact lens crafted with natural-toned hues that enhance and accentuate your eyes.",
    "meta.title.fresh": "Discover ACUVUE® DEFINE® Fresh",
    "meta.desc.fresh": "1-DAY ACUVUE® DEFINE® FRESH coloured contact lens with nature-inspired brightening colours to craft your own beautiful.",
}

export default meta_data;